import { MrfiktivHttpClientProvider } from "../../mrfiktiv-http-client.provider";
import {
  MrfiktivBaseChartItemListViewmodelGen,
  MrfiktivInvoiceChartItemListViewModelGen,
  MrfiktivReportWeeklyAnalysisPerPartnerViewmodelGen,
  MrfiktivStatusDistributionAnalyticsViewModelGen
} from "../../v1/data-contracts";
import { FleetAnalytics } from "../../v1/FleetAnalytics";
import { HttpClient } from "../../v1/http-client";

class FleetAnalyticsService {
  /**
   * The HttpClient containing the Axios Instance
   */
  client: HttpClient;

  /**
   * The proxy.
   */
  proxy: FleetAnalytics;

  /**
   * @class Initialize ThgService
   */
  constructor(clientProvider: MrfiktivHttpClientProvider) {
    this.client = clientProvider.client();
    this.proxy = new FleetAnalytics(this.client);
  }

  /**
   *
   * Gets the invoices net sum per damage type in a time range
   *
   * @returns
   */
  async getTotalSubtotalPerDamageType(
    partnerId: string,
    fleetId: string,
    from: string,
    to: string
  ): Promise<MrfiktivInvoiceChartItemListViewModelGen> {
    const response = await this.proxy.fleetAnalyticsControllerGetTotalSubtotalByDamageType({
      partnerId,
      fleetId,
      from,
      to
    });

    return response.data;
  }

  /**
   *
   * Gets the invoices net sum per coverage type in a time range
   *
   * @returns
   */
  async getTotalSubtotalPerCoverageType(
    partnerId: string,
    fleetId: string,
    from: string,
    to: string
  ): Promise<MrfiktivInvoiceChartItemListViewModelGen> {
    const response = await this.proxy.fleetAnalyticsControllerGetTotalSubtotalByCoverageType({
      partnerId,
      fleetId,
      from,
      to
    });

    return response.data;
  }

  /**
   *
   * Gets the amount of reports per damge type in a time range
   *
   * @returns
   */
  async getCountPerDamageType(
    partnerId: string,
    fleetId: string,
    from: string,
    to: string
  ): Promise<MrfiktivBaseChartItemListViewmodelGen> {
    const response = await this.proxy.fleetAnalyticsControllerDamageType({
      partnerId,
      fleetId,
      from,
      to
    });

    return response.data;
  }

  /**
   *
   * Gets the amount of reports per coverage type in a time range
   *
   * @returns
   */
  async getCountPerCoverageType(
    partnerId: string,
    fleetId: string,
    from: string,
    to: string
  ): Promise<MrfiktivBaseChartItemListViewmodelGen> {
    const response = await this.proxy.fleetAnalyticsControllerCoverageType({
      partnerId,
      fleetId,
      from,
      to
    });

    return response.data;
  }
  /**
   *
   * Gets the amount of reports per trip type in a time range
   *
   * @returns
   */
  async getCountPerTripType(
    partnerId: string,
    fleetId: string,
    from: string,
    to: string
  ): Promise<MrfiktivBaseChartItemListViewmodelGen> {
    const response = await this.proxy.fleetAnalyticsControllerTripType({
      partnerId,
      fleetId,
      from,
      to
    });

    return response.data;
  }

  /**
   *
   * Gets the report status distribution data
   *
   * @returns
   */
  async getStatusDistribution(
    partnerId: string,
    fleetId: string,
    from: string,
    to: string
  ): Promise<MrfiktivStatusDistributionAnalyticsViewModelGen> {
    const response = await this.proxy.fleetAnalyticsControllerStatusDistribution({ partnerId, fleetId, from, to });

    return response.data;
  }

  /**
   *
   * Gets the report status distribution data
   *
   * @returns
   */
  async getWeekdayAnalysis(
    partnerId: string,
    fleetId: string,
    from: string,
    to: string
  ): Promise<MrfiktivReportWeeklyAnalysisPerPartnerViewmodelGen> {
    const response = await this.proxy.fleetAnalyticsControllerReportWeekdayAnalysisPerPartner({
      partnerId,
      fleetId,
      from,
      to
    });

    return response.data;
  }

  /**
   *
   * Gets the average of damge type total
   *
   * @returns
   */
  async getDamageTypeAverage(
    partnerId: string,
    fleetId: string,
    from: string,
    to: string
  ): Promise<MrfiktivBaseChartItemListViewmodelGen> {
    const response = await this.proxy.fleetAnalyticsControllerDamageTypeAverage({
      partnerId,
      fleetId,
      from,
      to
    });

    return response.data;
  }

  /**
   *
   * Gets the report status distribution data
   *
   * @returns
   */
  async getTotalSubtotalBySeller(
    partnerId: string,
    fleetId: string,
    from: string,
    to: string
  ): Promise<MrfiktivInvoiceChartItemListViewModelGen> {
    const response = await this.proxy.fleetAnalyticsControllerGetTotalSubtotalByInvoiceSeller({
      partnerId,
      fleetId,
      from,
      to
    });

    return response.data;
  }
}

export default new FleetAnalyticsService(new MrfiktivHttpClientProvider());
